module.exports = __webpack_public_path__ + "img/package-list-hd-bg.d5634862.png";